export const toTest = () => "/test";
export const toCategories = () => "/kategorie";
export const toHomePage = () => "/home";
export const toRepetition = () => "/nauka-slowek";
export const toWords = () => "/slowka";